import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class DoubleUpTextAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "doubleUpText",
        STATES: {
            GLOW: "glow",
        },
    };

    constructor() {
        super(DoubleUpTextAnimation.ANIMATION_CONFIG.NAME);
        this.play(DoubleUpTextAnimation.ANIMATION_CONFIG.STATES.GLOW, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/DoubleUpTextAnimation.ts